<template>
    <form class="p-contact__form bg-prim-light is-rounded p-3" method="post" @submit.prevent="submit">
        <loader v-if="loading"></loader>
        <div class="form-row">
            <div class="col-sm">
                <div class="form-group">
                    <label for="name">Name*</label>
                    <input id="name"
                        class="form-control"
                        type="text"
                        autocomplete="given-name"
                        v-model="form.name"
                        required />
                </div>
            </div>
            <div class="col-sm">
                <div class="form-group">
                    <label for="surname">Surname*</label>
                    <input id="surname"
                        class="form-control"
                        type="text"
                        autocomplete="family-name"
                        v-model="form.surname"
                        required />
                </div>
            </div>
            <div class="col-sm">
                <div class="form-group">
                    <label for="country">Country*</label>
                    <select
                        class="form-control custom-select"
                        autocomplete="country-name"
                        v-model="form.country"
                        required>
                        <option></option>
                        <option v-for="c in countries" v-bind:key="c.id">{{ c.name }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="col-sm">
                <div class="form-group">
                    <label for="phone">Phone*</label>
                    <input id="phone"
                        class="form-control"
                        type="text"
                        autocomplete="tel"
                        v-model="form.phone"
                        required />
                </div>
            </div>
            <div class="col-sm">
                <div class="form-group">
                    <label for="email">Email*</label>
                    <input id="email"
                        class="form-control"
                        type="email"
                        autocomplete="email"
                        v-model="form.email"
                        required />
                </div>
            </div>
        </div>
        
        <div class="form-group">
            <label>Trip type*</label>
            <div class="mt-2">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="trip-type-oneway" name="tripType" value="oneway" v-model="form.tripType" required>
                    <label class="form-check-label" for="trip-type-oneway">One way</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="trip-type-return" name="tripType" value="return" v-model="form.tripType" required>
                    <label class="form-check-label" for="trip-type-return">Return</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="trip-type-daytrip" name="tripType" value="daytrip" v-model="form.tripType" required>
                    <label class="form-check-label" for="trip-type-daytrip">Day trip</label>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="col-sm">
                <div class="form-group">
                    <label for="adults">Number of adults* <small>(14+ years)</small></label>
                    <input id="adults"
                        class="form-control"
                        type="number"
                        min="0"
                        step="1"
                        v-model="form.adults"
                        required />
                </div>
            </div>
            <div class="col-sm">
                <div class="form-group">
                    <label for="children">Number of children* <small>(6-14 years)</small></label>
                    <input id="children"
                        class="form-control"
                        type="number"
                        min="0"
                        step="1"
                        v-model="form.children"
                        required />
                </div>
            </div>
            <div class="col-sm">
                <div class="form-group">
                    <label for="infants">Number of infants* <small>(0-5 years)</small></label>
                    <input id="infants"
                        class="form-control"
                        type="number"
                        min="0"
                        step="1"
                        v-model="form.infants"
                        required />
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="col-sm">
                <div class="form-group">
                    <label for="outDate">Outward date*</label>
                    <input id="outDate"
                        class="form-control"
                        type="date"
                        v-model="form.outDate"
                        required />
                </div>
            </div>
            <div class="col-sm">
                <div class="form-group">
                    <label for="outOrigin">Origin port*</label>
                    <select
                        class="form-control custom-select"
                        v-model="form.outOrigin"
                        required>
                        <option></option>
                        <option v-for="port in ports" v-bind:key="port.id">{{ port.name }}</option>
                    </select>
                </div>
            </div>
            <div class="col-sm">
                <div class="form-group">
                    <label for="outDestination">Destination port*</label>
                    <select
                        class="form-control custom-select"
                        v-model="form.outDestination"
                        required>
                        <option></option>
                        <option v-for="port in ports" v-bind:key="port.id">{{ port.name }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="form-row" v-if="['return', 'daytrip'].includes(form.tripType)">
            <div class="col-sm">
                <div class="form-group">
                    <label for="retDate">Return date*</label>
                    <input id="retDate"
                        class="form-control"
                        type="date"
                        v-model="form.retDate"
                        required
                        :min="minReturnDate"
                        :disabled="form.tripType != 'return'" />
                </div>
            </div>
            <div class="col-sm">
                <div class="form-group">
                    <label for="outOrigin">Origin port*</label>
                    <select
                        class="form-control custom-select"
                        v-model="form.retOrigin"
                        required>
                        <option></option>
                        <option v-for="port in ports" v-bind:key="port.id">{{ port.name }}</option>
                    </select>
                </div>
            </div>
            <div class="col-sm">
                <div class="form-group">
                    <label for="retDestination">Destination port*</label>
                    <select
                        class="form-control custom-select"
                        v-model="form.retDestination"
                        required>
                        <option></option>
                        <option v-for="port in ports" v-bind:key="port.id">{{ port.name }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="form-group">
            <label for="comment">Comments</label>
            <textarea id="comment" 
                class="form-control" 
                cols="30" 
                rows="5"
                v-model="form.comment"></textarea>
        </div>
                
        <button class="btn btn-primary w-100" type="submit">Send a message</button>
    </form>
</template>

<script>
import Loader from '../components/Loader.vue'
import qs from 'qs'
import countries from '../constants/countries'

export default {
  components: { Loader },
    props: {
        title: String,
        subtitle: String,
        nonce: String,
    },
    data() {
        return {
            loading: false,
            form: {
                name: '',
                surname: '',
                country: '',
                phone: '',
                email: '',
                adults: '',
                children: '',
                infants: '',
                comment: '',
                tripType: '',
                outDate: '',
                outOrigin: '',
                outDestination: '',
                retDate: '',
                retOrigin: '',
                retDestination: '',
            },
            countries: countries,
            ports: window.venezialines.ports,
        }
    },
    computed: {
        tripType() {
            return this.form.tripType
        },
        outDate() {
            return this.form.outDate
        },
        minReturnDate() {
            if (this.form.tripType == 'return') {
                let date = this.form.outDate ? moment(this.form.outDate).add(1, 'days') : moment()
                return date.format('YYYY-MM-DD')
            }

            return null
        }
    },
    watch: {
        tripType(newValue) {
            if (newValue == 'daytrip') {
                this.form.retDate = this.form.outDate
            }
        },
        outDate(newValue) {
            if (this.tripType == 'daytrip') {
                this.form.retDate = this.form.outDate
            }
        },
    },
    methods: {
        submit() {
            this.loading = true
            axios.post(venezialines.ajaxurl, qs.stringify({
                action: 'group_inquiry_form_submit',
                _ajax_nonce: this.nonce,
                name: this.form.name,
                surname: this.form.surname,
                trip_type: this.form.tripType,
                email: this.form.email,
                phone: this.form.phone,
                out_date: this.form.outDate,
                out_origin: this.form.outOrigin,
                out_destination: this.form.outDestination,
                ret_date: this.form.retDate,
                ret_origin: this.form.retOrigin,
                ret_destination: this.form.retDestination,
                adults: this.form.adults,
                children: this.form.children,
                infants: this.form.infants,
                comment: this.form.comment,
                country: this.form.country,
            })).then(response => {
                Object.keys(this.form).forEach(field => this.form[field] = '')
                this.$swal('Your message has been sent!', '', 'success')
            }).catch(err => {
                let response = err.response
                let message
                let callback
                if (response.data && response.data.data) {
                    message = Object.values(response.data.data).map(error => error.message).join("\n")
                } else if (response.data == -1) {
                    message = 'Your message could not be sent, please try again'
                    callback = () => window.location.reload()
                } else {
                    message = 'Your message could not be sent due to an unexpected error'
                }
                this.$swal('Error', message, 'error').then(() => callback && callback())
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>